






























































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { topicWebservice } from '@/webservices/topic';
import type { Topic } from '@/models/topic';
import type { User } from '@/models/user';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'TopicsList',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {},
})
export default class TopicsList extends Vue {
    private topics = new Array<Topic>();

    private tableSettings = {
        isStriped: true,
        isHoverable: true,
        isPaginated: false,
        perPage: 50,
    };
    @Getter('account/userInfo') private userInfo: User;

    private mounted() {
        this.load();
    }
    private load() {
        const self = this;
        topicWebservice
            .load()
            .then((response) => {
                const filteredTopics = response.data.filter((topic: Topic) => {
                    return topic.title !== 'Nicht zugeordnete Lehren';
                });

                self.topics = filteredTopics.sort((a: Topic, b: Topic) => {
                    return a.title.localeCompare(b.title);
                });
            })
            .catch((error) => {
                console.error(error);
            });
    }
}
